import type { Contract } from '~/data/schemas/contract';

/**
 * The contracts covering one elevator. A contract reaches a car through its property, so
 * a car is covered when it appears in `propertyContracts` for its own property — the
 * property has to match as well as the car, since the same contract can cover several
 * buildings.
 *
 * The invoice page's `selectCoveringContracts` does the same walk but keeps a governing
 * contract even without car overlap, because `activeContractId` is a fact about an
 * invoice. A car has no governing contract.
 *
 * Split out so the tab's count can be taken without mounting the tab.
 */
export function selectCarContracts(
  contracts: Contract[],
  propertyId: string | undefined,
  carId: string | undefined,
): Contract[] {
  if (!propertyId || !carId) return [];

  return contracts.filter((contract) =>
    contract.propertyContracts.some(
      (propertyContract) =>
        propertyContract.propertyId === propertyId &&
        propertyContract.cars.some((car) => car.carId === carId),
    ),
  );
}
